import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import { StyledLabel } from './style.js';

function Label(_a) {
    var id = _a.id, label = _a.label, props = __rest(_a, ["id", "label"]);
    if (!label.trim()) {
        return null;
    }
    return (React.createElement(StyledLabel, __assign({ htmlFor: id }, props), label));
}

export { Label as default };
